var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portfolio-write-component',{attrs:{"portfolio-type":'portfolioWrite'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }